import { useCallback, useEffect, useState } from 'react';
import { listPromotions } from '../services/promotionsApi';

const EMPTY_LOOKUP = { publication: {}, request: {} };

const buildLookup = (items = []) => {
  const next = {
    publication: {},
    request: {},
  };
  items.forEach(item => {
    if (!item?.resourceType || !item?.resourceId) return;
    if (!next[item.resourceType]) {
      next[item.resourceType] = {};
    }
    next[item.resourceType][item.resourceId] = item.id;
  });
  return next;
};

export default function usePromotionLookup() {
  const [lookup, setLookup] = useState(EMPTY_LOOKUP);

  const refresh = useCallback(async () => {
    try {
      const items = await listPromotions();
      setLookup(buildLookup(items));
    } catch (error) {
      console.warn('No se pudieron obtener las promociones registradas.', error);
      setLookup(EMPTY_LOOKUP);
    }
  }, []);

  useEffect(() => {
    let ignore = false;
    const load = async () => {
      try {
        const items = await listPromotions();
        if (!ignore) {
          setLookup(buildLookup(items));
        }
      } catch (error) {
        if (!ignore) {
          console.warn('No se pudieron obtener las promociones.', error);
          setLookup(EMPTY_LOOKUP);
        }
      }
    };

    load();

    const handler = () => {
      refresh();
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('flotte:promotions-updated', handler);
    }

    return () => {
      ignore = true;
      if (typeof window !== 'undefined') {
        window.removeEventListener('flotte:promotions-updated', handler);
      }
    };
  }, [refresh]);

  const isPromoted = useCallback(
    (resourceType, resourceId) => Boolean(lookup?.[resourceType]?.[resourceId]),
    [lookup]
  );

  const getPromotionId = useCallback(
    (resourceType, resourceId) => lookup?.[resourceType]?.[resourceId] || null,
    [lookup]
  );

  return {
    lookup,
    refresh,
    isPromoted,
    getPromotionId,
  };
}
